<template>  
    <div class="XR-mobile-todaynew1 yingxiao todaynew" v-if="todayShow">
      <div class="title">
        <!-- <div class="todayLeft">
          <img src=" ../../../static/true4.png" alt="">
        </div> 新年样式-->
        <div class="todayMiddle">
           <div class="center"><!-- <img src="http://frontend.xurigo.com/icon/todaynew.png">--><span class="big">今日上新</span></div> 
            <span class="small">每天都在上新</span>
        </div>
       
        <!-- <div class="todayRight">
          <img src=" ../../../static/true4.png" alt="">
        </div>  新年样式-->
      </div>
      <div ref="prolist" :class="'pro-list '">
        <div  :style="{width:proListWidth+'px'}">
          <div class="pro-list-group">
            <template v-for="(pItem,index) in group1">
              <div :class="'item '+ ((index+1)%3==0?'':'marginright')" :style="{width: todayNewItemWidth +'px'}" :key="pItem.SkuId">
                <div class="category">{{pItem.CategoryName}}</div>
                <div class="name">{{pItem.AliasName?pItem.AliasName:pItem.Name}}</div>            
                <router-link :to="'/retail/productDetail?skuId='+pItem.SkuId">
                  <img :src="pItem.Images&&pItem.Images.length>0? pItem.Images[0].ImgPath:IMGServer_URL+'/images/index-item-default.png'" class="tdnew-pro-img" :style="{height:todayNewItemWidth+'px'}">
                </router-link>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {  
  name:'XR-mobile-todaynew1',
  data() {
    return {
      todayNewItemWidth: (document.documentElement.clientWidth -6 )/3,
      productList:[],
      group1:[],
      group2:[],
      todayfloorIndex:0,
      todayfloorCount:0,
      todayfloorTime:0,
      proleft:0,
      proleft2:0,
      left:0,
      left2:0,
      todayShow:true
    }
  },
  props: {
    data : {}
  },
  mounted:function(){    
    this.getNewProduct();
  },
  computed:{
    proLeft:function(){
    var proleft = document.documentElement.clientWidth
    return proleft

    },
    proListWidth : function(){
      var width = this.todayfloorCount * (document.documentElement.clientWidth+6)*2-18;
      return width;
    }
  },
  methods:{
    todayfloorGun:function(){
        for(var i=0;i<this.productList.length;i++){
            this.group1.push(this.productList[i])
          }
        var a = 3-this.productList.length%3
        for(var i=0;i<a; i++){
            this.group1.push(this.productList[i])
          } 
        var timer = setInterval(()=>{
          this.getTransformLeft();
        },3000)  
        if(Math.ceil(this.group1.length/3)==1){
            clearInterval(timer)
        }
    },
    getTransformLeft(){            
          this.left-=this.proLeft
          var groupWidth = this.proListWidth*0.5   
          this.dom.transition = '0s'
          var mul =Math.ceil(this.group1.length/3) 
            if(this.left==-this.proLeft*mul){
              this.left=0             
              this.setTransform(0)
              return                
            }  
            else{
            this.setTransform(this.left)
            this.dom.transition= 'all 500ms ease 0s'
            }    
          
    },
    setTransform(num){            
            this.dom.transform = `translate3d(${num}px,0px,0px)`
            this.dom['-webkit-transform'] = `translate3d(${num}px,0px,0px)`
            this.dom['-ms-transform'] = `translate3d(${num}px,0px,0px)`                   
        },
    getNewProduct:function(){
      const ths = this;
      var json = {type:2, pageIndex:1,pageSize:9};
      this.$post("/Shop/RetailServer/GetServiceProductList",json)
      .then(function(res) {
        if (res.IsSuccess) {          
          ths.productList = res.Data
		  if (ths.productList.length > 0 && ths.productList.length < 6){
			var tempData = res.Data
			var tempLength = tempData.length
			while (ths.productList.length < 6) {
			  for (var i=0;i<tempLength;i++){
			    ths.productList.push(tempData[i])
			  }
			}
		  }
          ths.todayfloorCount = Math.ceil(res.Data.length / 3)      
          ths.todayfloorGun()   
          ths.dom = document.querySelectorAll('.pro-list-group')[0].style 
          ths.dom2 = document.querySelectorAll('.item').style 
        }
        ths.todayShow = ths.productList.length==0?false:true
      })
      .catch(function(err) {
        console.log(err);
      });    
    }
  }
}
</script>

<style>


.XR-mobile-todaynew1.yingxiao.todaynew {
  overflow: hidden;
  padding: 0;
}
.XR-mobile-todaynew1.yingxiao.todaynew .title {
  display: flex;
  justify-content: center;
  align-items: center;
}
.XR-mobile-todaynew1.yingxiao.todaynew .title .todayLeft{
  width: 33%;
  text-align: right;
}
.XR-mobile-todaynew1.yingxiao.todaynew .title .todayLeft img{
  width: 27px;
}
.XR-mobile-todaynew1.yingxiao.todaynew .title .todayMiddle{
  width: 34%;
  text-align: center;
}
.XR-mobile-todaynew1.yingxiao.todaynew .title .todayRight{
  width: 33%;
  text-align: left;
 
}
.XR-mobile-todaynew1.yingxiao.todaynew .title .todayRight img{
  width: 27px;
}
.XR-mobile-todaynew1.yingxiao.todaynew .title .big {
  color: #530c68;
}

.XR-mobile-todaynew1.yingxiao.todaynew .listItem{
  float: left;
}
.XR-mobile-todaynew1.yingxiao.todaynew .pro-list {
  overflow: hidden;
  background: #eeeeee;
  height:182px;
}
.XR-mobile-todaynew1.yingxiao.todaynew .pro-list .pro-list-group{ width: 100%; float: left;}

.XR-mobile-todaynew1.yingxiao.todaynew .pro-list .item {
  float: left;
  background: white;
  padding-bottom: 5px;
}
.XR-mobile-todaynew1.yingxiao.todaynew .pro-list .item.marginright {
  margin-right: 3px;
}
.XR-mobile-todaynew1.yingxiao.todaynew .pro-list .item img {
  width: 90%;
  margin: 0 5%;
  display: block;
}
.XR-mobile-todaynew1.yingxiao.todaynew .pro-list .item .category {
  color: Black;
  padding: 7% 0 0;
  line-height: 20px;
  text-align: center;
}
.XR-mobile-todaynew1.yingxiao.todaynew .pro-list .item .name {
  line-height: 20px;
  margin: 0 0 5%;
  text-align: center;
  height: 20px;
  overflow: hidden;

}
</style>



// WEBPACK FOOTER //
// src/components/index/mobile/todaynew1/todaynew.vue